export const getters = {
    systemAccounttypes: state => state.accounttypes,
    Accounttype: state => state.systemAccounttype
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/accounttypes/getters.js